import { render, staticRenderFns } from "./ImagePreviewDialog.vue?vue&type=template&id=23b85b93&scoped=true"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewDialog.vue?vue&type=style&index=0&id=23b85b93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b85b93",
  null
  
)

export default component.exports